<template>
  <div id="cotizador">
    <loading :active.sync="isLoading" color="#00AB63"></loading>

    <b-navbar
      toggleable="lg"
      class="bg-createch"
      v-if="!['cotizacion_id'].includes($route.name)"
    >
      <b-navbar-brand href="#">
        <a class="navbar-brand mr-auto mr-lg-0" href="#">
          <img src="./../../assets/img/logo.svg" height="60" width="auto" alt />
        </a>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <router-link class="nav-link boton_createch_2" to="/inicio"
            >Regresar</router-link
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <full-page :options="options_full" ref="fullpage"> 
      <div class="section">
        <div class="slide p-2"> 
          <b-container v-if="show" class="mt-5">
            
            <b-row class="justify-content-md-center">
              <b-col sm="10" style="padding:0px !important">
                <b-alert show variant="danger" v-if="delete_package"
                  >Advertencia, Posiblemente se borro el paquete de esta
                  cotización.</b-alert
                >
                <b-button
                  pill
                  class="btn-createch"
                  v-on:click="add_client = !add_client"
                  >Agregar cliente</b-button
                >
                <b-button
                  pill
                  class="btn-createch ml-2"
                  v-on:click="add_service = !add_service"
                  >Agregar No. servicio</b-button
                >
              </b-col>
            </b-row> 
            <b-row class="justify-content-md-center">
              <b-col sm="10 my-3 p-3 bg-white rounded shadow-sm">
                <h4>Información del cliente</h4>
                <hr />
                <b-row>
                  <b-col sm="8">
                    <b-form-group label="Cliente">
                      <v-select
                        label="email"
                        class="style-chooser"
                        :options="clientes"
                        v-model="data.cliente"
                      >
                        <span slot="no-options">No hay resultados.</span>
                        <template slot="option" slot-scope="option"
                          >{{ option.firstname }} {{ option.lastname }} -
                          {{ option.email }}</template
                        >
                      </v-select>
                    </b-form-group>
                    <b-row>
                      <b-col>
                        <b-form-group label="Nombre" v-if="data.cliente">
                          <b-form-input
                            v-model="data.cliente.firstname"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="Apellido" v-if="data.cliente">
                          <b-form-input
                            v-model="data.cliente.lastname"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-if="data.cliente">
                      <b-col sm="10">
                        <b-form-group label="No. Servicio">
                          <v-select
                            label="snumber"
                            class="style-chooser"
                            v-model="data.servicio"
                            v-if="servicios"
                            :options="servicios"
                          >
                            <span slot="no-options">No hay resultados.</span>
                            <template slot="option" slot-scope="option">{{
                              option.snumber
                            }}</template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col sm="1" v-if="data.servicio">
                        <b-button
                          pill
                          class="btn-createch"
                          style="margin-top:30px;"
                          v-on:click="editarServices()"
                          >Editar</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row v-if="esSupervisor() || esAdministrador()">
                      <b-col sm="8">
                        <b-form-group label="Empleado">  
                          <v-select
                            label="email"
                            class="style-chooser"
                            :options="usuarios_empleados"
                            v-model="usuarios_empleados_seleccionado"
                          >
                            <span slot="no-options">No hay resultados.</span>
                            <template slot="option" slot-scope="option"
                              >{{ option.firstname }} {{ option.lastname }} -
                              {{ option.email }}</template
                            >
                          </v-select>
                        </b-form-group>  
                      </b-col>
                      <b-col sm="4">
                        <b-button
                          pill
                          class="btn-createch"
                          style="margin-top:30px;"
                          v-on:click="cambiarEmpleado()"
                          >Asignar cotización</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="4">
                     
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div
          class="slide mt-5 p-2"
          id="consumo"
          style="overflow-y: scroll; height:100%"
        >
          <b-container>
            <b-alert show variant="danger" v-if="this.data.cliente == null"
              >Para correcto funcionamiento es necesario que eligas un
              cliente.</b-alert
            >
            <b-alert show variant="danger" v-if="this.data.servicio == null"
              >Para correcto funcionamiento es necesario que eligas un no. de
              servicio.</b-alert
            >
            <b-row
              class="justify-content-md-center"
              v-if="this.data.cliente != null && this.data.servicio != null"
            >
              <b-col sm="12 p-3 bg-white rounded shadow-sm">
                <h4>Información de consumo</h4>
                <hr />
                <b-row>
                  <b-col sm="6">
                    <b-table
                      :items="data.consumo_mensual.slice(0, 12)"
                      :fields="consumo_fields"
                    >
                      <template v-slot:cell(precio)="data">
                        {{
                          Intl.NumberFormat("es-MX", {
                            style: "currency",
                            currency: "MXN",
                          }).format(data.item.precio)
                        }}
                      </template>
                    </b-table>
                  </b-col>
                  <b-col sm="4">
                    <table style="text-align:center; " border="0">
                      <thead>
                        <tr>
                          <th scope="col" style="height:50px">kWh/mes</th>
                          <th
                            scope="col"
                            style="height:50px"
                            v-if="data.tipo_recibo != 'Medio'"
                          >
                            $ Pago
                          </th>
                          <th
                            scope="col"
                            style="height:50px"
                            v-if="data.tipo_recibo == 'Medio'"
                          >
                            $ Precio medio
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in data.data_consumo.slice(
                            0,
                            12
                          )"
                          :key="index"
                          v-if="data.tipo_ingreso == 'Medio'"
                        >
                          <th scope="row">
                            <b-input-group
                              id="input-group-3"
                              label-for="input-3"
                              class
                            >
                              <b-input-group-prepend
                                is-text
                                v-if="
                                  data.tipo_ingreso == 'Medio' && index % 2 == 0
                                "
                              >
                                <i class="fas fa-bolt"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                class="input_consumo"
                                v-model="item.consumo"
                                required
                                type="number"
                                v-on:change="
                                  ConsumoMensual($event, index, item)
                                "
                                v-if="
                                  data.tipo_ingreso == 'Medio' && index % 2 == 0
                                "
                                :disabled="data.tipo_ingreso == null"
                              />
                            </b-input-group>
                          </th>
                          <th scope="row">
                            <b-input-group
                              id="input-group-3"
                              label-for="input-3"
                              class="mb-1"
                            >
                              <b-input-group-prepend
                                is-text
                                v-if="
                                  data.tipo_ingreso == 'Medio' && index % 2 == 0
                                "
                              >
                                <i class="fas fa-dollar-sign"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                class="input_consumo"
                                v-model="item.pago"
                                required
                                type="number"
                                v-on:change="
                                  ConsumoMensual($event, index, item)
                                "
                                v-if="
                                  data.tipo_ingreso == 'Medio' && index % 2 == 0
                                "
                                :disabled="data.tipo_ingreso == null"
                              />
                            </b-input-group>
                          </th>
                        </tr>
                        <tr
                          v-for="(item, index) in data.data_consumo.slice(
                            0,
                            12
                          )"
                          :key="index"
                          v-if="data.tipo_ingreso != 'Medio'"
                        >
                          <th scope="row">
                            <b-input-group
                              id="input-group-3"
                              label-for="input-3"
                              class
                            >
                              <b-input-group-prepend is-text>
                                <i class="fas fa-bolt"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                class="input_consumo"
                                v-model="item.consumo"
                                required
                                type="number"
                                v-on:change="
                                  ConsumoMensual($event, index, item)
                                "
                                :disabled="data.tipo_ingreso == null"
                              />
                            </b-input-group>
                          </th>
                          <th scope="row">
                            <b-input-group
                              id="input-group-3"
                              label-for="input-3"
                              class="mb-1"
                            >
                              <b-input-group-prepend is-text>
                                <i class="fas fa-dollar-sign"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                class="input_consumo"
                                v-model="item.pago"
                                required
                                type="number"
                                v-on:change="
                                  ConsumoMensual($event, index, item)
                                "
                                :disabled="data.tipo_ingreso == null"
                              />
                            </b-input-group>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                  <b-col sm="2">
                    <span>Tipo de ingreso</span>
                    {{ data.tipo_ingreso }}
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        v-model="data.tipo_ingreso"
                        :options="tipo_ingreso"
                        required
                      ></b-form-select>
                    </b-form-group>
                    <span>Tipo de recibo</span>
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        v-model="data.tipo_recibo"
                        :options="tipo_recibo"
                        required
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <div
          class="slide mt-5 p-2"
          id="proyecto_solar"
          style="overflow-y: scroll; height:100%"
        >
          <b-container>
            <b-row class="justify-content-md-center"> 
              <b-col sm="12 p-3 bg-white rounded shadow-sm">
                <h4>Proyecto solar</h4>  
                <hr />
                <b-row>
                  <b-col sm="2">
                    <p>Tamaño</p>
                     <span>{{ tamano }} Kwp</span> 
                  </b-col>
                  <b-col sm="2">
                    <p>Producción mensual</p>
                    <span>{{ formatKwh(ProduccionMensual) }} Kwh</span>
                  </b-col>
                  <b-col sm="2">
                    <p>Precio del sistema</p>
                    <span>{{
                      Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                      }).format(totalMasCuotaPesos)
                    }}</span>
                  </b-col>
                  <b-col sm="2">
                    <p>Ahorro anual</p>
                    <span> ${{ ahorroAnual }} </span>
                  </b-col>

                  <b-col sm="2">
                    <p>Promedio mensual de consumo</p>
                    <span>{{ formatKwh(consumo_total / 12) }} Kwh</span>
                  </b-col>
                  <b-col sm="2">
                    <p>Retorno de la inversión</p>
                    <span
                      >{{
                        (totalMasCuotaPesos / ahorroAnual).toFixed(2)
                      }}
                      Años</span
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="2">
                    <p>Perdida</p>
                    <span
                      >{{
                        GetPerdida(
                          data.perdida.inclinacion,
                          data.perdida.orientacion
                        )
                      }}
                      %</span
                    >
                  </b-col>
                  <b-col sm="2"> </b-col>
                  <b-col sm="2"> </b-col>
                  <b-col sm="2"> </b-col>

                  <b-col sm="2"> </b-col>
                  <b-col sm="2"> </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col sm="5">
                    <b-row>
                      <b-col sm="4">
                        <b-form-input
                          type="number"
                          v-model="data.perdida.inclinacion"
                          style="
                          width: 100%;
                          max-width: 100px;
                          float: right;
                          margin-top: 10px;
                          background: transparent !important;
                          border-radius: 0px !important;
                          border none !important;
                        border-bottom: 2px solid rgb(0, 171, 99) !important;
                        border-top: 0px !important;
                        border-left: 0px !important;
                        border-right: 0px !important;
                        "
                        ></b-form-input>
                        <p style="text-align: center;">Inclinación</p>
                      </b-col>
                      <b-col sm="8">
                        <img
                          src="./../../assets/img/perdida2.png"
                          height="60"
                          width="auto"
                          alt
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-input
                          type="number"
                          v-model="data.perdida.orientacion"
                          style=" width: 100%;
                          max-width: 100px; 
                          margin: 10px auto;
                          background: transparent !important;
                          border-radius: 0px !important;
                          border none !important;
                        border-bottom: 2px solid rgb(0, 171, 99) !important;
                        border-top: 0px !important;
                        border-left: 0px !important;
                        border-right: 0px !important;"
                        ></b-form-input>
                        <p style="text-align: center;">Orientación</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    sm="7"
                    v-if="
                      packageSelected &&
                        packages.filter(
                          (word) => word.packageName == packageSelected
                        )[0].automatic
                    "
                  >
                    <b-row>
                      <b-col sm="6">
                        <input
                          type="range"
                          class="form-control-range"
                          min="0"
                          max="100"
                          step="1"
                          v-model="data.porcentaje_cobertura"
                        />
                      </b-col>
                      <b-col sm="6">
                        <span style="text-align:center;"
                          >{{ data.porcentaje_cobertura }}%</span
                        >
                        <h3>Porcentaje de cobertura elétrica</h3>
                              {{
                                    ((1-((this.data.consumo_mensual_ahorro
                                      .slice(12, 24)
                                      .reduce(
                                        (acc, item) =>
                                          Number(acc) + Number(item.pago),
                                        0
                                      )
                                      .toFixed(2))/total))*100).toFixed(2)
                                  }}
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    v-if="
                      packageSelected &&
                        !packages.filter(
                          (word) => word.packageName == packageSelected
                        )[0].automatic
                    "
                  >
                    <p>Porcentaje paquete</p>
                    <span> {{ data.porcentaje_cobertura }} %</span>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col sm="3">
                    <b-form-group label="Costo promedio de tarifa">
                      <b-form-input
                        type="number"
                        required
                        v-model="data.costo_promedio_tarifa"
                        disabled
                      />
                    </b-form-group>
                     <b-form-checkbox 
                      v-model="status"
                      value='true'
                      unchecked-value='false'
                    >
                    Público
                    </b-form-checkbox> 
                  </b-col>
                  
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-b-toggle.collapse-1
                      variant="primary"
                      class="toggle"
                      block
                      >Ver prospección de generación de energía</b-button
                    >
                    <b-collapse id="collapse-1" class="mt-2">
                      <b-row>
                        <b-col sm="5">
                          <b-table
                            :items="data.consumo_mensual.slice(0, 12)"
                            :fields="consumo_fields"
                          >
                            <!-- A custom formatted footer cell for field 'name' -->
                            <template v-slot:cell(precio)="data">
                              $ {{ data.item.precio }}
                            </template>
                            <template v-slot:cell(precio_promedio)="data">
                              $ {{ data.item.precio_promedio }}
                            </template>
                          </b-table>

                          <table class="table">
                            <tbody>
                              <tr style="text-align:center">
                                <th scope="row"></th>
                                <th scope="row">
                                  {{ consumo_total }}
                                </th>
                                <th scope="row">
                                  -
                                </th>
                                <th scope="row">$ {{ total }}</th>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                        <b-col sm="3">
                          <table
                            class="table table-striped"
                            style="text-align:center;"
                          >
                            <thead>
                              <tr>
                                <th scope="col">kWh/mes</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in calculos_generacion_inclinacion.slice( 12, 24)"
                                :key="index"
                              >
                                <th scope="row"> 
                                 {{item.generacion}}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <table
                            style="    text-align: center;
    width: 100%;
    border-top: 1px solid #ccc;
    margin-top: 17px;"
                          >
                            <tbody>
                              <tr>
                                <th style="padding: 15px;">
                                  
                                  {{ ProduccionMensual * 12 }}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                        <b-col sm="4">
                          <table
                            class="table table-success"
                            style="text-align:center;"
                          >
                            <thead>
                              <tr>
                                <th scope="col">kWh/mes</th>
                                <th scope="col">$Pago/mes</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item,
                                index) in data.consumo_mensual_ahorro.slice(
                                  12,
                                  24
                                )"
                                :key="index"
                              >
                                <th scope="row">
                                  {{ item.consumo }}
                                  <!-- {{total/30}} -->
                                </th>
                                <th scope="row">
                                  $ {{ item.pago }}
                                  <!-- {{total/30}} -->
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <table class="table" style="text-align:center;">
                            <thead>
                              <tr>
                                <th scope="col">
                                  {{
                                    this.data.consumo_mensual_ahorro
                                      .slice(12, 24)
                                      .reduce(
                                        (acc, item) =>
                                          Number(acc) + Number(item.consumo),
                                        0
                                      )
                                      .toFixed(2)
                                  }}
                                </th>
                                <th scope="col">
                                  $
                                  {{
                                    this.data.consumo_mensual_ahorro
                                      .slice(12, 24)
                                      .reduce(
                                        (acc, item) =>
                                          Number(acc) + Number(item.pago),
                                        0
                                      )
                                      .toFixed(2)
                                  }}
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </b-col>
                        <br />
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" v-if="data.servicio != null">
                    <b-form-group v-if="packages">
                      <div
                        v-for="(packagei, index) in packages"
                        v-bind:key="index"
                        style="float:left; margin-left:10px; padding-top:10px;"
                      >
                        <b-form-radio
                          v-model="packageSelected"
                          :value="packagei.packageName"
                          v-if="
                            packagei.compatibility == data.servicio.contractType
                          "
                          >{{ packagei.packageName }}</b-form-radio
                        >
                      </div> 
                      <b-form-radio
                        style="float:left; margin-left:10px; padding-top:10px;"
                        v-model="packageSelected"
                        :value="'original'"
                        v-if="data.rows && data.packageSelected"
                      >Cotización</b-form-radio> 
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <listaProductos
                      :rows="rows"
                      :productTypes="productTypes"
                      :products="products"
                      :AllProductsOptions="AllProductsOptions"
                      :getTotalPrice="getTotalPrice"
                      :getTotal="getTotal"
                      :verifyQuantity="verifyQuantity"
                      :selectProduct="selectProduct"
                    ></listaProductos>
                  </b-col>
                  <b-col sm="12" md="12" xl="12">
                    <b-row>
                      <b-col sm="6" md="3" xl="3">
                        <b-form-group label="Dolar:">
                          <b-form-input v-model="dollar" />
                        </b-form-group>
                        <b-button
                          class="boton_createch"
                          block
                          @click="updateDollar()"
                        >
                          <i class="far fa-save"></i> Guardar valor de dolar
                        </b-button>
                      </b-col>
                      <b-col sm="6" md="3" xl="3">
                        <b-form-group label="Costo por watt:">
                          <b-form-input
                            type="number"
                            v-model="data.costoWatt"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <tablaProductos
                      :rows="rows"
                      :products="products"
                      :total="totalUSD"
                      :totalPesos="totalPesos"
                      :subtotal="subtotal"
                      :subtotalPesos="subtotalPesos"
                      :totalIVA="totalIVA"
                      :totalIVAPesos="totalIVAPesos"
                      :disc="disc"
                      :discPesos="discPesos"
                      :cuota="cuota"
                      :totalMasCuota="totalMasCuota"
                      :cuotaPesos="cuotaPesos"
                      :totalMasCuotaPesos="totalMasCuotaPesos"
                      :getTotalPrice="getTotalPrice"
                      :getTotal="getTotal"
                      :verifyQuantity="verifyQuantity"
                      v-on:getDiscountValue="getDiscountValue"
                      v-on:getDiscountPesosValue="getDiscountPesosValue"
                    ></tablaProductos>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </b-container>
        </div>
        <div class="slide mt-5 p-2">
          <b-container>
            <b-row class="mt-5">
              <h4
                style="text-align:center; font-size: 42px !important; color:#00AB63 !important; width: 100%;"
              >
                Cotización
              </h4>
            </b-row>
            <b-row class="mt-5">
              <b-col>
                <b-button
                  pill
                  variant="primary"
                  block
                  class="boton_createch"
                  @click="addQuote()"
                >
                  <i class="far fa-save"></i> Guardar nueva cotización
                </b-button>
              </b-col>
              <b-col v-if="this.$route.params.id">
                <b-button
                  pill
                  variant="primary"
                  block
                  class="boton_createch"
                  @click="putQuote()"
                >
                  <i class="far fa-save"></i> Actualizar cotización
                </b-button>
              </b-col>
              <b-col v-if="this.$route.params.id">
                <b-button
                  pill
                  variant="primary"
                  block
                  class="boton_createch"
                  @click="openPDF()"
                >
                  <i class="far fa-save"></i> verPDF
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <ul class="actions">
        <li
          @click="$refs.fullpage.api.moveSlideLeft()"
          class="actions-button btn-circle btn-xl"
          style="float:left;"
        >
          <i class="fas fa-arrow-left"></i>
        </li>
        <li
          @click="$refs.fullpage.api.moveSlideRight()"
          class="actions-button btn-circle btn-xl"
          style="float:right;"
        >
          <i class="fas fa-arrow-right"></i>
        </li>
      </ul>
    </full-page>
    <b-sidebar title="Agregar nuevo cliente" :visible="add_client">
      <div class="px-3 py-2">
        <b-row>
          <b-col>
            <p v-if="errors.length">
              <b-alert
                show
                variant="danger"
                v-for="(error, index) in errors"
                :key="index"
                >{{ error }}</b-alert
              >
            </p>
            <form @submit="checkForm">
              <b-form-group label="Nombres">
                <b-form-input
                  v-model="newCliente.firstname"
                  type="text"
                  placeholder="Nombre"
                />
              </b-form-group>
              <b-form-group label="Apellidos">
                <b-form-input
                  v-model="newCliente.lastname"
                  type="text"
                  placeholder="Apellidos"
                />
              </b-form-group>
              <div v-if="phoneNumber">
                {{ phoneNumber.nationalNumber }}
              </div>
              <b-form-group label="Teléfono">
                <b-form-input
                  v-model="newCliente.phoneNumber"
                  type="number"
                  placeholder="Teléfono"
                />
              </b-form-group>
              <b-form-group label="Correo electronico">
                <b-form-input
                  v-model="newCliente.email"
                  type="email"
                  placeholder="Correo electronico"
                />
              </b-form-group>
              <b-button
                variant="primary"
                block
                class="boton_createch"
                type="submit"
                value="Submit"
              >
                <i class="far fa-save"></i> Guardar
              </b-button>
            </form>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>
    <b-sidebar
      title="Agregar No. Servicio"
      :visible="add_service"
      width="600px"
    >
      <div class="px-3 py-2">
        <b-container>
          <p v-if="errors2.length">
            <b-alert
              show
              variant="danger"
              v-for="(error, index) in errors2"
              :key="index"
              >{{ error }}</b-alert
            >
          </p>
          <form @submit="checkForm2">
            <b-row>
              <b-col>
                <b-form-group label="Cliente">
                  <v-select
                    label="email"
                    class="style-chooser"
                    :options="clientes"
                    v-model="newService.client"
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template slot="option" slot-scope="option"
                      >{{ option.firstname }} {{ option.lastname }} -
                      {{ option.email }}</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="No. servicio">
                  <b-form-input
                    type="text"
                    required
                    placeholder="No. servicio"
                    v-model="newService.number"
                  />
                </b-form-group>
                <b-form-group label="Dirección">
                  <b-form-input
                    type="text"
                    required
                    placeholder="Dirección"
                    v-model="newService.address"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Ubicación">
                  <v-select
                    label="name"
                    required
                    :options="ciudades"
                    v-model="newService.city"
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template
                      slot="option2"
                      slot-scope="option2"
                      v-if="newService.city != null"
                      >{{ option2.name }}</template
                    >
                  </v-select>
                </b-form-group>
                <b-form-group label="Tarifa" v-if="newService.city != null">
                  <v-select
                    label="name"
                    :options="newService.city.tariffs"
                    v-model="newService.tariff"
                    required
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template slot="option2" slot-scope="option2">{{
                      option2.name
                    }}</template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="Nombre">
                  <b-form-input
                    type="text"
                    required
                    placeholder="Nombre"
                    v-model="newService.contact.name"
                  />
                </b-form-group>
                <b-form-group label="Teléfono">
                  <b-form-input
                    type="number"
                    required
                    placeholder="Teléfono"
                    v-model="newService.contact.phoneNumber"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Correo electrónico">
                  <b-form-input
                    type="email"
                    required
                    placeholder="Correo electrónico"
                    v-model="newService.contact.email"
                  />
                </b-form-group>
                <b-form-checkbox
                  v-model="sameClient"
                  value="true"
                  unchecked-value="false"
                  v-if="newService.client != null"
                  >Mismo cliente</b-form-checkbox
                >
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <!--
                <b-form-group>
                  <b-form-select :options="tipo_recibo" v-model="newService.billType" required></b-form-select>
                </b-form-group>
                   -->
                <b-form-group>
                  <b-form-select
                    :options="tipo_contrato"
                    v-model="newService.contractType"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button block class="boton_createch" type="submit" value="Submit">
              <i class="far fa-save"></i> Guardar
            </b-button>
          </form>
        </b-container>
      </div>
    </b-sidebar>
    <b-sidebar
      title="Editar No. Servicio"
      :visible="edit_service"
      width="600px"
    >
      <div class="px-3 py-2">
        <b-container>
          <b-form>
            <b-row>
              <b-col>
                <b-form-group label="Cliente">
                  <v-select
                    label="email"
                    class="style-chooser"
                    :options="clientes"
                    v-model="newService.client"
                    disabled
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template slot="option" slot-scope="option"
                      >{{ option.firstname }} {{ option.lastname }} -
                      {{ option.email }}</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="No. servicio">
                  <b-form-input
                    type="text"
                    required
                    placeholder="No. servicio"
                    v-model="newService.number"
                    disabled
                  />
                </b-form-group>
                <b-form-group label="Dirección">
                  <b-form-input
                    type="text"
                    required
                    placeholder="Dirección"
                    v-model="newService.address"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Ubicación">
                  <v-select
                    label="name"
                    required
                    :options="ciudades"
                    v-model="newService.city"
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template
                      slot="option2"
                      slot-scope="option2"
                      v-if="newService.city != null"
                      >{{ option2.name }}</template
                    >
                  </v-select>
                </b-form-group>
                <b-form-group label="Tarifa" v-if="newService.city != null">
                  <v-select
                    label="name"
                    :options="newService.city.tariffs"
                    v-model="newService.tariff"
                    required
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template slot="option2" slot-scope="option2">{{
                      option2.name
                    }}</template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="Nombre">
                  <b-form-input
                    type="text"
                    required
                    placeholder="Nombre"
                    v-model="newService.contact.name"
                  />
                </b-form-group>
                <b-form-group label="Teléfono">
                  <b-form-input
                    type="text"
                    required
                    placeholder="Teléfono"
                    v-model="newService.contact.phoneNumber"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Correo electrónico">
                  <b-form-input
                    type="email"
                    required
                    placeholder="Correo electrónico"
                    v-model="newService.contact.email"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr />

            <b-row>
              <b-col>
                <!-- 
                <b-form-group>
                  <b-form-select :options="tipo_recibo" v-model="newService.billType" required></b-form-select>
                </b-form-group>
                 -->
                <b-form-group>
                  <b-form-select
                    :options="tipo_contrato"
                    v-model="newService.contractType"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button v-on:click="putServices()" block class="boton_createch">
              <i class="far fa-save"></i> Actualizar
            </b-button>
          </b-form>
        </b-container>
      </div>
    </b-sidebar>
  </div>
</template>
<script>
import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/storage";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import listaProductos from "../../components/paquetes/listaProductos";
import tablaProductos from "../../components/paquetes/tablaProductos";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    Loading,
    listaProductos,
    tablaProductos,
    VuePhoneNumberInput,
  },
  data() {
    return {
      status: false,
      errors: [],
      usuarios_empleados: [],
      usuarios_empleados_seleccionado: null,
      errors2: [],
      phoneNumber: null,
      delete_package: false,
      isLoading: false,
      show: true,
      add_client: false,
      edit_service: false,
      newCliente: {
        firstname: null,
        lastname: null,
        phoneNumber: null,
        email: null,
      },
      newService: {
        client: null,
        city: null,
        number: null,
        address: null,
        contact: {
          name: null,
          phoneNumber: null,
          email: null,
        },
        //billType: null,
        contractType: null,
        tariff: null,
      },
      add_service: false,
      options_full: {
        menu: "#menu_cotizador",
        navigation: false,
        slidesNavigation: true,
        controlArrows: false,
        normalScrollElements: ".style-chooser, .pruebas",
        keyboardScrolling: false,
        slidesNavPosition: "top",
        navigationPosition: "center",
        anchors: ["page1", "page2", "page3", "page4", "page5", "page6"],
        sectionsColor: ["#f8f9fa", "#f8f9fa"],
        verticalCentered: false,
        autoScrolling: false,
        fitToSection: true,
      },
      data: {
        calculos_generacion_inclinacion: [
          { mes: 'enero', generacion: null },
          { mes: 'febrero', generacion: null },
          { mes: 'marzo', generacion: null },
          { mes: 'abril', generacion: null},
          { mes: 'mayo', generacion: null },
          { mes: 'junio', generacion: null},
          { mes: 'julio', generacion: null },
          { mes: 'agosto',generacion: null  },
          { mes: 'septiembre', generacion: null },
          { mes: 'octubre',generacion: null },
          { mes: 'noviembre', generacion: null },
          { mes: 'diciembre', generacion: null },
          { mes: 'enero', generacion: null},
          { mes: 'febrero', generacion: null },
          { mes: 'marzo', generacion: null },
          { mes: 'abril', generacion: null },
          { mes: 'mayo', generacion: null },
          { mes: 'junio', generacion: null },
          { mes: 'julio', generacion: null},
          { mes: 'agosto', generacion: null },
          { mes: 'septiembre', generacion: null },
          { mes: 'octubre', generacion: null },
          { mes: 'noviembre', generacion: null },
          { mes: 'diciembre', generacion: null } 
      ],
        ProduccionMensual: null,
        cliente: null,
        retornoInversion: null,
        ahorroAnual: null,
        servicio: null,
        tipo_recibo: null,
        tipo_ingreso: null,
        ahorro_consumo_total: null,
        ahorro_total: null,
        tamano_total_panekes: null,
        consumo_mensual: [
          {
            mes: "Enero",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Febrero",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Marzo",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Abril",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Mayo",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Junio",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Julio",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Agosto",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Septiembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Octubre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Noviembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Diciembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Enero",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Febrero",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Marzo",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Abril",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Mayo",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Junio",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Julio",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Agosto",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Septiembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Octubre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Noviembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
          {
            mes: "Diciembre",
            consumo: null,
            precio_promedio: null,
            precio: null,
            precio_calculado: null,
          },
        ],
        data_consumo: [
          { mes: "Enero", consumo: null, pago: null },
          { mes: "Febrero", consumo: null, pago: null },
          { mes: "Marzo", consumo: null, pago: null },
          { mes: "Abril", consumo: null, pago: null },
          { mes: "Mayo", consumo: null, pago: null },
          { mes: "Junio", consumo: null, pago: null },
          { mes: "Julio", consumo: null, pago: null },
          { mes: "Agosto", consumo: null, pago: null },
          { mes: "Septiembre", consumo: null, pago: null },
          { mes: "Octubre", consumo: null, pago: null },
          { mes: "Noviembre", consumo: null, pago: null },
          { mes: "Diciembre", consumo: null, pago: null },
          { mes: "Enero", consumo: null, pago: null },
          { mes: "Febrero", consumo: null, pago: null },
          { mes: "Marzo", consumo: null, pago: null },
          { mes: "Abril", consumo: null, pago: null },
          { mes: "Mayo", consumo: null, pago: null },
          { mes: "Junio", consumo: null, pago: null },
          { mes: "Julio", consumo: null, pago: null },
          { mes: "Agosto", consumo: null, pago: null },
          { mes: "Septiembre", consumo: null, pago: null },
          { mes: "Octubre", consumo: null, pago: null },
          { mes: "Noviembre", consumo: null, pago: null },
          { mes: "Diciembre", consumo: null, pago: null },
        ],
        consumo_mensual_ahorro: [
          { mes: "Enero", consumo: 0, pago: 0 },
          { mes: "Febrero", consumo: 0, pago: 0 },
          { mes: "Marzo", consumo: 0, pago: 0 },
          { mes: "Abril", consumo: 0, pago: 0 },
          { mes: "Mayo", consumo: 0, pago: 0 },
          { mes: "Junio", consumo: 0, pago: 0 },
          { mes: "Julio", consumo: 0, pago: 0 },
          { mes: "Agosto", consumo: 0, pago: 0 },
          { mes: "Septiembre", consumo: 0, pago: 0 },
          { mes: "Octubre", consumo: 0, pago: 0 },
          { mes: "Noviembre", consumo: 0, pago: 0 },
          { mes: "Diciembre", consumo: 0, pago: 0 },
          { mes: "Enero", consumo: 0, pago: 0 },
          { mes: "Febrero", consumo: 0, pago: 0 },
          { mes: "Marzo", consumo: 0, pago: 0 },
          { mes: "Abril", consumo: 0, pago: 0 },
          { mes: "Mayo", consumo: 0, pago: 0 },
          { mes: "Junio", consumo: 0, pago: 0 },
          { mes: "Julio", consumo: 0, pago: 0 },
          { mes: "Agosto", consumo: 0, pago: 0 },
          { mes: "Septiembre", consumo: 0, pago: 0 },
          { mes: "Octubre", consumo: 0, pago: 0 },
          { mes: "Noviembre", consumo: 0, pago: 0 },
          { mes: "Diciembre", consumo: 0, pago: 0 },
        ],
        total: null,
        consumo_total: null,
        medio_total: null,
        porcentaje_cobertura: 100,
        tamano: null,
        costo_promedio_tarifa: 0,
        perdida: {
          orientacion: 0,
          inclinacion: 25,
        },
        pack: {
          products: [],
        },
        rows: [],
        packageSelected: "",
        costoWatt: 110, 
      },
      clientes: [],

      ciudades: [],
      tarifas: null,
      servicios: null,
      tipo_ingreso: [
        { text: "Tipo de cobro", value: null },
        { text: "Cobro Mensual", value: "Mensual" },
        { text: "Cobro Bimensual", value: "Medio" },
      ],
      tipo_recibo: [
        { text: "Tipo de recibo", value: null },
        { text: "Pago Mensual", value: "Mensual" },
        { text: "Precio medio", value: "Medio" },
      ],
      tipo_contrato: [
        { text: "Tipo de contrato", value: null },
        { text: "Doméstico", value: "Doméstico" },
        { text: "Industrial", value: "Industrial" },
        { text: "Comercial", value: "Comercial" },
      ],
      sameClient: "",
      perdidas: [
        // 0
        { Orientacion: 0, Inclinacion: -90, value: -9.5 },
        { Orientacion: 0, Inclinacion: -75, value: -9.5 },
        { Orientacion: 0, Inclinacion: -60, value: -9.5 },
        { Orientacion: 0, Inclinacion: -45, value: -9.5 },
        { Orientacion: 0, Inclinacion: -30, value: -9.5 },
        { Orientacion: 0, Inclinacion: -15, value: -9.5 },
        { Orientacion: 0, Inclinacion: 0, value: -9.5 },
        { Orientacion: 0, Inclinacion: 15, value: -9.5 }, 
        { Orientacion: 0, Inclinacion: 30, value: -9.5 },
        { Orientacion: 0, Inclinacion: 45, value: -9.5 },
        { Orientacion: 0, Inclinacion: 60, value: -9.5 },
        { Orientacion: 0, Inclinacion: 75, value: -9.5 },
        { Orientacion: 0, Inclinacion: 90, value: -9.5 },
        // 5
        { Orientacion: 5, Inclinacion: -90, value: -9.4 },
        { Orientacion: 5, Inclinacion: -75, value: -8.6 },
        { Orientacion: 5, Inclinacion: -60, value: -7.9 },
        { Orientacion: 5, Inclinacion: -45, value: -7.3 },
        { Orientacion: 5, Inclinacion: -30, value: -6.8 },
        { Orientacion: 5, Inclinacion: -15, value: -6.5 },
        { Orientacion: 5, Inclinacion: 0, value: -6.3 },
        { Orientacion: 5, Inclinacion: 15, value: -6.4 },
        { Orientacion: 5, Inclinacion: 30, value: -6.7 },
        { Orientacion: 5, Inclinacion: 45, value: -7.2 },
        { Orientacion: 5, Inclinacion: 60, value: -7.8 },
        { Orientacion: 5, Inclinacion: 75, value: -8.5 },
        { Orientacion: 5, Inclinacion: 90, value: -9.3 },
        // 10
        { Orientacion: 10, Inclinacion: -90, value: -9.8 },
        { Orientacion: 10, Inclinacion: -75, value: -8.3 },
        { Orientacion: 10, Inclinacion: -60, value: -6.9 },
        { Orientacion: 10, Inclinacion: -45, value: -5.6 },
        { Orientacion: 10, Inclinacion: -30, value: -4.7 },
        { Orientacion: 10, Inclinacion: -15, value: -4.1 },
        { Orientacion: 10, Inclinacion: 0, value: -3.8 },
        { Orientacion: 10, Inclinacion: 15, value: -4.0 },
        { Orientacion: 10, Inclinacion: 30, value: -4.6 },
        { Orientacion: 10, Inclinacion: 45, value: -5.5 },
        { Orientacion: 10, Inclinacion: 60, value: -6.8 },
        { Orientacion: 10, Inclinacion: 75, value: -8.2 },
        { Orientacion: 10, Inclinacion: 90, value: -9.7 },
        // 15
        { Orientacion: 15, Inclinacion: -90, value: -10.3 },
        { Orientacion: 15, Inclinacion: -75, value: -8.1 },
        { Orientacion: 15, Inclinacion: -60, value: -6.1 },
        { Orientacion: 15, Inclinacion: -45, value: -4.4 },
        { Orientacion: 15, Inclinacion: -30, value: -3.1 },
        { Orientacion: 15, Inclinacion: -15, value: -2.3 },
        { Orientacion: 15, Inclinacion: 0, value: -1.9 },
        { Orientacion: 15, Inclinacion: 15, value: -2.2 },
        { Orientacion: 15, Inclinacion: 30, value: -3.0 },
        { Orientacion: 15, Inclinacion: 45, value: -4.3 },
        { Orientacion: 15, Inclinacion: 60, value: -6.0 },
        { Orientacion: 15, Inclinacion: 75, value: -7.9 },
        { Orientacion: 15, Inclinacion: 90, value: -10.1 },
        // 20
        { Orientacion: 20, Inclinacion: -90, value: -11.3 },
        { Orientacion: 20, Inclinacion: -75, value: -8.5 },
        { Orientacion: 20, Inclinacion: -60, value: -5.9 },
        { Orientacion: 20, Inclinacion: -45, value: -3.8 },
        { Orientacion: 20, Inclinacion: -30, value: -2.1 },
        { Orientacion: 20, Inclinacion: -15, value: -1.1 },
        { Orientacion: 20, Inclinacion: 0, value: -0.7 },
        { Orientacion: 20, Inclinacion: 15, value: -1.0 },
        { Orientacion: 20, Inclinacion: 30, value: -2.0 },
        { Orientacion: 20, Inclinacion: 45, value: -3.6 },
        { Orientacion: 20, Inclinacion: 60, value: -5.7 },
        { Orientacion: 20, Inclinacion: 75, value: -8.3 },
        { Orientacion: 20, Inclinacion: 90, value: -11.1 },
        // 25
        { Orientacion: 25, Inclinacion: -90, value: -12.3 },
        { Orientacion: 25, Inclinacion: -75, value: -8.9 },
        { Orientacion: 25, Inclinacion: -60, value: -6.0 },
        { Orientacion: 25, Inclinacion: -45, value: -3.6 },
        { Orientacion: 25, Inclinacion: -30, value: -1.7 },
        { Orientacion: 25, Inclinacion: -15, value: -0.5 },
        { Orientacion: 25, Inclinacion: 0, value: 0.0 },
        { Orientacion: 25, Inclinacion: 15, value: -0.4 },
        { Orientacion: 25, Inclinacion: 30, value: -1.5 },
        { Orientacion: 25, Inclinacion: 45, value: -3.4 },
        { Orientacion: 25, Inclinacion: 60, value: -5.8 },
        { Orientacion: 25, Inclinacion: 75, value: -8.7 },
        { Orientacion: 25, Inclinacion: 90, value: -12.1 },
        // 30
        { Orientacion: 30, Inclinacion: -90, value: -13.9 },
        { Orientacion: 30, Inclinacion: -75, value: -10.0 },
        { Orientacion: 30, Inclinacion: -60, value: -6.6 },
        { Orientacion: 30, Inclinacion: -45, value: -3.9 },
        { Orientacion: 30, Inclinacion: -30, value: -1.9 },
        { Orientacion: 30, Inclinacion: -15, value: -0.5 },
        { Orientacion: 30, Inclinacion: 0, value: -0.0 },
        { Orientacion: 30, Inclinacion: 15, value: -0.4 },
        { Orientacion: 30, Inclinacion: 30, value: -1.7 },
        { Orientacion: 30, Inclinacion: 45, value: -3.7 },
        { Orientacion: 30, Inclinacion: 60, value: -6.3 },
        { Orientacion: 30, Inclinacion: 75, value: -9.7 },
        { Orientacion: 30, Inclinacion: 90, value: -13.6 },
        // 35
        { Orientacion: 35, Inclinacion: -90, value: -15.3 },
        { Orientacion: 35, Inclinacion: -75, value: -11.1 },
        { Orientacion: 35, Inclinacion: -60, value: -7.6 },
        { Orientacion: 35, Inclinacion: -45, value: -4.7 },
        { Orientacion: 35, Inclinacion: -30, value: -2.5 },
        { Orientacion: 35, Inclinacion: -15, value: -1.2 },
        { Orientacion: 35, Inclinacion: 0, value: -0.7 },
        { Orientacion: 35, Inclinacion: 15, value: -1.1 },
        { Orientacion: 35, Inclinacion: 30, value: -2.4 },
        { Orientacion: 35, Inclinacion: 45, value: -4.5 },
        { Orientacion: 35, Inclinacion: 60, value: -7.3 },
        { Orientacion: 35, Inclinacion: 75, value: -10.8 },
        { Orientacion: 35, Inclinacion: 90, value: -15.0 },
        // 40
        { Orientacion: 40, Inclinacion: -90, value: -17.4 },
        { Orientacion: 40, Inclinacion: -75, value: -12.7 },
        { Orientacion: 40, Inclinacion: -60, value: -8.9 },
        { Orientacion: 40, Inclinacion: -45, value: -6.0 },
        { Orientacion: 40, Inclinacion: -30, value: -3.9 },
        { Orientacion: 40, Inclinacion: -15, value: -2.5 },
        { Orientacion: 40, Inclinacion: 0, value: -2.0 },
        { Orientacion: 40, Inclinacion: 15, value: -2.3 },
        { Orientacion: 40, Inclinacion: 30, value: -3.6 },
        { Orientacion: 40, Inclinacion: 45, value: -5.7 },
        { Orientacion: 40, Inclinacion: 60, value: -8.6 },
        { Orientacion: 40, Inclinacion: 75, value: -12.3 },
        { Orientacion: 40, Inclinacion: 90, value: -17.1 },
        // 45
        { Orientacion: 45, Inclinacion: -90, value: -19.4 },
        { Orientacion: 45, Inclinacion: -75, value: -14.6 },
        { Orientacion: 45, Inclinacion: -60, value: -10.8 },
        { Orientacion: 45, Inclinacion: -45, value: -7.8 },
        { Orientacion: 45, Inclinacion: -30, value: -5.7 },
        { Orientacion: 45, Inclinacion: -15, value: -4.3 },
        { Orientacion: 45, Inclinacion: 0, value: -3.9 },
        { Orientacion: 45, Inclinacion: 15, value: -4.2 },
        { Orientacion: 45, Inclinacion: 30, value: -5.4 },
        { Orientacion: 45, Inclinacion: 45, value: -7.5 },
        { Orientacion: 45, Inclinacion: 60, value: -10.5 },
        { Orientacion: 45, Inclinacion: 75, value: -14.3 },
        { Orientacion: 45, Inclinacion: 90, value: -18.7 },
      ],
      consumo_fields: [
        { key: "mes", label: "Mes" },
        { key: "consumo", label: "kWh/mes" },
        { key: "precio_promedio", label: "Precio Medio" },
        { key: "precio", label: "$Pago/mes" },
      ],
      employee: null,
      subtotal: 0,
      subtotalPesos: 0,
      totalUSD: 0,
      totalPesos: 0,
      totalIVA: 0,
      totalIVAPesos: 0,
      disc: 0,
      discPesos: 0,
      iva: 16,
      dollar: 20,
      percentage: 0,
      cuota: 0,
      cuotaPesos: 0,
      totalMasCuota: 0,
      totalMasCuotaPesos: 0,
      packages: [],
      packageOptions: [],
      products: [],
      rows: [
        {
          product: null,
          quantity: 1,
          options: [],
          type: null,
          price: 0,
          pricePesos: 0,
          disc: 0,
          discPesos: 0,
          showDisc: false,
        },
      ],
      productTypes: [],
      AllProductsOptions: [{ text: "Selecciona producto", value: null }],
      packageSelected: "",
      ahorroAnual: 0,
      tarifas: null,
      generacion_mensual_inclinacion: {
        _20grados: [
          { mes: 'enero', horas: 5.55, porcentaje: 7.43 },
          { mes: 'febrero', horas: 6.06, porcentaje: 8.11 },
          { mes: 'marzo', horas: 7.13, porcentaje: 9.54 },
          { mes: 'abril', horas: 7.08, porcentaje: 9.48 },
          { mes: 'mayo', horas: 7.11, porcentaje: 9.52 },
          { mes: 'junio', horas: 6.69, porcentaje: 8.95 },
          { mes: 'julio', horas: 6.02, porcentaje: 8.06 },
          { mes: 'agosto', horas: 5.83, porcentaje: 7.80 },
          { mes: 'septiembre', horas: 5.85, porcentaje: 7.83 },
          { mes: 'octubre', horas: 6.38, porcentaje: 8.54 },
          { mes: 'noviembre', horas: 5.79, porcentaje: 7.75 },
          { mes: 'diciembre', horas: 5.23, porcentaje: 7.00 },
          { mes: 'enero', horas: 5.55, porcentaje: 7.43 },
          { mes: 'febrero', horas: 6.06, porcentaje: 8.11 },
          { mes: 'marzo', horas: 7.13, porcentaje: 9.54 },
          { mes: 'abril', horas: 7.08, porcentaje: 9.48 },
          { mes: 'mayo', horas: 7.11, porcentaje: 9.52 },
          { mes: 'junio', horas: 6.69, porcentaje: 8.95 },
          { mes: 'julio', horas: 6.02, porcentaje: 8.06 },
          { mes: 'agosto', horas: 5.83, porcentaje: 7.80 },
          { mes: 'septiembre', horas: 5.85, porcentaje: 7.83 },
          { mes: 'octubre', horas: 6.38, porcentaje: 8.54 },
          { mes: 'noviembre', horas: 5.79, porcentaje: 7.75 },
          { mes: 'diciembre', horas: 5.23, porcentaje: 7.00 }
        ],
        _10grados: [
          { mes: 'enero', horas: 4.86, porcentaje: 6.59 },
          { mes: 'febrero', horas: 5.53, porcentaje: 7.50 },
          { mes: 'marzo', horas: 6.88, porcentaje: 9.34 },
          { mes: 'abril', horas: 7.26, porcentaje: 9.85 },
          { mes: 'mayo', horas: 7.72, porcentaje: 10.47 },
          { mes: 'junio', horas: 7.4, porcentaje: 10.04 },
          { mes: 'julio', horas: 6.55, porcentaje: 8.89 },
          { mes: 'agosto', horas: 6.09, porcentaje: 8.26 },
          { mes: 'septiembre', horas: 5.82, porcentaje: 7.90 },
          { mes: 'octubre', horas: 5.94, porcentaje: 8.06 },
          { mes: 'noviembre', horas: 5.12, porcentaje: 6.95 },
          { mes: 'diciembre', horas: 4.53, porcentaje: 6.15 },
          { mes: 'enero', horas: 4.86, porcentaje: 6.59 },
          { mes: 'febrero', horas: 5.53, porcentaje: 7.50 },
          { mes: 'marzo', horas: 6.88, porcentaje: 9.34 },
          { mes: 'abril', horas: 7.26, porcentaje: 9.85 },
          { mes: 'mayo', horas: 7.72, porcentaje: 10.47 },
          { mes: 'junio', horas: 7.4, porcentaje: 10.04 },
          { mes: 'julio', horas: 6.55, porcentaje: 8.89 },
          { mes: 'agosto', horas: 6.09, porcentaje: 8.26 },
          { mes: 'septiembre', horas: 5.82, porcentaje: 7.90 },
          { mes: 'octubre', horas: 5.94, porcentaje: 8.06 },
          { mes: 'noviembre', horas: 5.12, porcentaje: 6.95 },
          { mes: 'diciembre', horas: 4.53, porcentaje: 6.15 }
        ],
        _5grados: [
          { mes: 'enero', horas: 4.24, porcentaje: 6.00 },
          { mes: 'febrero', horas: 4.99, porcentaje: 7.06 },
          { mes: 'marzo', horas: 6.48, porcentaje: 9.17 },
          { mes: 'abril', horas: 7.14, porcentaje: 10.10 },
          { mes: 'mayo', horas: 7.88, porcentaje: 11.15 },
          { mes: 'junio', horas: 7.65, porcentaje: 10.83 },
          { mes: 'julio', horas: 6.71, porcentaje: 9.50 },
          { mes: 'agosto', horas: 6.08, porcentaje: 8.60 },
          { mes: 'septiembre', horas: 5.63, porcentaje: 7.97 },
          { mes: 'octubre', horas: 5.44, porcentaje: 7.70 },
          { mes: 'noviembre', horas: 4.51, porcentaje: 6.38 },
          { mes: 'diciembre', horas: 3.91, porcentaje: 5.53 },
          { mes: 'enero', horas: 4.24, porcentaje: 6.00 },
          { mes: 'febrero', horas: 4.99, porcentaje: 7.06 },
          { mes: 'marzo', horas: 6.48, porcentaje: 9.17 },
          { mes: 'abril', horas: 7.14, porcentaje: 10.10 },
          { mes: 'mayo', horas: 7.88, porcentaje: 11.15 },
          { mes: 'junio', horas: 7.65, porcentaje: 10.83 },
          { mes: 'julio', horas: 6.71, porcentaje: 9.50 },
          { mes: 'agosto', horas: 6.08, porcentaje: 8.60 },
          { mes: 'septiembre', horas: 5.63, porcentaje: 7.97 },
          { mes: 'octubre', horas: 5.44, porcentaje: 7.70 },
          { mes: 'noviembre', horas: 4.51, porcentaje: 6.38 },
          { mes: 'diciembre', horas: 3.91, porcentaje: 5.53 }
        ]
      },
      calculos_generacion_inclinacion: [
          { mes: 'enero', generacion: null },
          { mes: 'febrero', generacion: null },
          { mes: 'marzo', generacion: null },
          { mes: 'abril', generacion: null},
          { mes: 'mayo', generacion: null },
          { mes: 'junio', generacion: null},
          { mes: 'julio', generacion: null },
          { mes: 'agosto',generacion: null  },
          { mes: 'septiembre', generacion: null },
          { mes: 'octubre',generacion: null },
          { mes: 'noviembre', generacion: null },
          { mes: 'diciembre', generacion: null },
          { mes: 'enero', generacion: null},
          { mes: 'febrero', generacion: null },
          { mes: 'marzo', generacion: null },
          { mes: 'abril', generacion: null },
          { mes: 'mayo', generacion: null },
          { mes: 'junio', generacion: null },
          { mes: 'julio', generacion: null},
          { mes: 'agosto', generacion: null },
          { mes: 'septiembre', generacion: null },
          { mes: 'octubre', generacion: null },
          { mes: 'noviembre', generacion: null },
          { mes: 'diciembre', generacion: null } 
      ],
      
      
    };
  },
  async created() {
    await this.getProducts();
    await this.getTarifas();
    await this.getClientes();
    await this.getCiudades();
    await this.getCotizacion(); 
  },
  watch: {
    
    dollar: function(newValue, oldValue) {
      this.rows.map((row) => {
        row.pricePesos = row.price * newValue;
      });
      this.getTotal();
    },
    "data.cliente": function() {
      let me = this;
      axios
        .get("snumbers/" + this.data.cliente._id)
        .then(function(response) {
          me.servicios = response.data;
        })
        .catch(function(error) {});
    },
    packageSelected: function() {
      this.selectPackage();
      this.CalcularProductos();
    },
    sameClient: function() {
      if (this.sameClient == "true") {
        this.newService.contact.name =
          this.newService.client.firstname +
          " " +
          this.newService.client.lastname;
        this.newService.contact.email = this.newService.client.email;
        this.newService.contact.phoneNumber = this.newService.client.phoneNumber;
      } else {
        this.newService.contact.name = "";
      }
    },
    "data.tamano": function() {
      this.CalcularProductos();
    },
    "usuarios_empleados": function(){  
      this.usuarios_empleados_seleccionado =  this.usuarios_empleados.find(empleado => empleado._id === this.employee._id);
    },
    
    GetPerdida: function() {
      this.GetPerdida(this.data.perdida.inclinacion, data.perdida.orientacion);
    },
    percentage: function() {
      for (let index = 0; index < this.products.length; index++) {
        if (this.products[index].priceWDisc > 0) {
          this.products[index].priceWDisc =
            this.products[index].priceWDisc * (1 + this.percentage / 100);
          this.products[index].price =
            this.products[index].price * (1 + this.percentage / 100);
        } else {
          this.products[index].priceWDisc =
            this.products[index].priceWDisc * (1 + this.percentage / 100);
          this.products[index].price =
            this.products[index].price * (1 + this.percentage / 100);
        }
      }
    },   
    /** 
    "data.tipo_ingreso": function(){
       this.vaciarConsumo();
    },
    "data.tipo_recibo": function(){
       this.vaciarConsumo();
    }
      */
  },
  methods: {
    generacion_inclinacion(inclinacion, mes){
      if(inclinacion <= 5){
        return (this.generacion_mensual_inclinacion._5grados[mes-1].porcentaje)/100;
      } else {
        if(inclinacion >= 5 && inclinacion <= 10 ){
          return (this.generacion_mensual_inclinacion._10grados[mes-1].porcentaje)/100;
        } else {
          return (this.generacion_mensual_inclinacion._20grados[mes-1].porcentaje)/100;
        } 
      }
    },
    checkForm: function(e) {
      this.errors = [];
      if (!this.newCliente.firstname)
        this.errors.push("Escribe un nombre correcto.");
      if (!this.newCliente.lastname)
        this.errors.push("Escribe un apellido correcto.");
      if (!this.newCliente.email) {
        this.errors.push("Escribe un correco electrónico");
      } else if (!this.validEmail(this.newCliente.email)) {
        this.errors.push("Escribe un correco electrónico valido");
      }
      if (!this.newCliente.phoneNumber) {
        this.errors.push("Escribe un teléfono");
      } else if (!this.validPhone(this.newCliente.phoneNumber)) {
        this.errors.push("Escribe un teléfono valido");
      }
      if (!this.errors.length) {
        this.registrar();
      }
      e.preventDefault();
    },
    checkForm2: function(e) {
      this.errors2 = [];
      if (!this.newService.contact.email) {
        this.errors2.push("Escribe un correco electrónico");
      } else if (!this.validEmail(this.newService.contact.email)) {
        this.errors2.push("Escribe un correco electrónico valido");
      }
      if (!this.newService.contact.phoneNumber) {
        this.errors2.push("Escribe un teléfono");
      } else if (!this.validPhone(this.newService.contact.phoneNumber)) {
        this.errors2.push("Escribe un teléfono valido");
      }
      if (!this.errors2.length) {
        this.addServices();
      }
      e.preventDefault();
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone: function(phone) {
      var re = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/;
      return re.test(phone);
    },
    openPDF() { 
      window.open(
        "https://services.createchenergias.mx/pdf/?id=" +JSON.parse(JSON.stringify(this.$route.params.id))+"&token="+this.token(),
        "_blank"
      );
    },
    token() {
      return this.$store.state.token
    },
    getCompanyValues() {
      axios
        .get(`values/${this.$store.state.usuario.empresa}`)
        .then((res) => {
          this.dollar = res.data.dollar;
          this.percentage = res.data.percentage;
        })
        .catch((error) => {
          this.dollar = 20;
        });
    },
    updateDollar() {
      axios
        .put(`company/${this.$store.state.usuario.empresa}/dollar`, {
          dollar: this.dollar,
        })
        .then((res) => {
          this.makeToast("Valor de dolar guardado", "Paquetes");
        })
        .catch((error) => {
          this.makeToast(
            "Ocurrió un error al guardar el valor de dolar",
            "Paquetes"
          );
        });
    },
    getPackages() {
      axios.get("quotationpackages").then((res) => {
        this.packages = res.data;
        this.packageOptions = res.data.map((pack) => ({
          text: pack.packageName,
          value: pack.packageName,
        }));
        this.packageOptions.push({
          text: "Personalizado",
          value: "",
        });
        this.isLoading = false;
      });
    },
    getProducts() {
      this.isLoading = true;
      axios.get("products").then((res) => {
        if (res.data) {
          this.products = res.data;
          for (const p of this.products) {
            if (p.brand != null && p.brand.name) {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: ${p.brand.name}`,
                value: this.products.indexOf(p),
              });
            } else {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: N/A`,
                value: this.products.indexOf(p),
              });
            }
          }
          for (let index = 0; index < this.products.length; index++) {
            if (this.products[index].priceWDisc > 0) {
              this.products[index].priceWDisc =
                this.products[index].priceWDisc * (1 + this.percentage / 100);
              this.products[index].price =
                this.products[index].price * (1 + this.percentage / 100);
            } else {
              this.products[index].priceWDisc =
                this.products[index].priceWDisc * (1 + this.percentage / 100);
              this.products[index].price =
                this.products[index].price * (1 + this.percentage / 100);
            }
          }
          this.rows[0].options = [...this.AllProductsOptions];
        }
      });
    },
    getProductTypes() {
      axios
        .get("types")
        .then((res) => {
          if (res.data) {
            this.productTypes.push({ text: "Selecciona tipo", value: null });
            for (const type of res.data) {
              this.productTypes.push({ text: type.name, value: type._id });
            }
          }
        })
        .catch((error) => {});
    },
    getTarifas() {
      let me = this;
      axios
        .get("tariffs")
        .then(function(response) {
          me.tarifas = response.data;
        })
        .catch(function(error) {});

      this.getProductTypes();
      this.getPackages();
      this.getCompanyValues();
    },
    getClientes() {
      let me = this;
      axios
        .get("customers/" + this.$store.state.usuario._id + "/status=true")
        .then(function(response) {
          me.clientes = response.data.customers;
        })
        .catch(function(error) {});
    },
    registrar() {
      this.isLoading = true;
      axios
        .post("user", {
          id_creador: this.$store.state.usuario._id,
          usuario: {
            firstname: this.newCliente.firstname,
            lastname: this.newCliente.lastname,
            email: this.newCliente.email,
            phoneNumber: this.newCliente.phoneNumber,
            rol: "Cliente",
          },
        })
        .then((respuesta) => {
          return respuesta;
        })
        .then((data) => {
          console.log(data);
          if (data.data.code == 202) {
            this.makeToast(
              this.$bvToast.toast("Usuario ya existe", {
                title: "Error",
                toaster: "b-toaster-top-right",
                variant: "danger",
                solid: true,
              })
            );
            this.isLoading = false;
          } else {
            if (data.data.code == 201) {
              this.newCliente.firstname = "";
              this.newCliente.lastname = "";
              this.newCliente.email = "";
              this.newCliente.phoneNumber = null;
              this.getClientes();
              this.isLoading = false;
              this.add_client = !this.add_client;
            } else {
              this.newCliente.firstname = "";
              this.newCliente.lastname = "";
              this.newCliente.email = "";
              this.newCliente.phoneNumber = null;
              this.getClientes();
              this.isLoading = false;
              this.add_client = !this.add_client;
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    getCiudades() {
      let me = this;
      axios
        .get("cities")
        .then(function(response) {
          me.ciudades = response.data;
        })
        .catch(function(error) {});
    },
    addServices() {
      this.isLoading = true;
      let assigned = this.$store.state.usuario._id;
      axios
        .post("snumber", {
          snumber: this.newService.number,
          address: this.newService.address,
          city: this.newService.city._id,
          contact: {
            phoneNumber: this.newService.contact.phoneNumber,
            name: this.newService.contact.name,
            email: this.newService.contact.email,
          },
          assignedTo: assigned,
          owner: this.newService.client._id,
          contractType: this.newService.contractType,
          //billType: this.newService.billType,
          tariff: this.newService.tariff._id,
        })
        .then((respuesta) => {
          return respuesta;
          this.isLoading = false;
        })
        .then((data) => {
          if (data.status == 201) {
            this.getServicios();
            this.add_service = !this.add_service;
            this.newService.snumber = null;
            this.newService.address = null;
            this.newService.contact.phoneNumber = null;
            this.newService.contact.name = null;
            this.newService.contact.email = null;
            this.newService.assignedTo = null;
            this.newService.owner = null;
            //this.newService.contractType = null;
            //this.newService.billType = null;
            this.newService.tariff = null;
            this.isLoading = false;
          } else {
            if (data.status == 202) {
              this.isLoading = false;
              this.makeToast(
                this.$bvToast.toast("Servicio ya se encuentra registrado", {
                  title: "Error",
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                  solid: true,
                })
              );
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    putServices() {
      this.isLoading = true;
      let assigned = this.$store.state.usuario._id;
      axios
        .put("snumber/" + this.data.servicio._id, {
          snumber: this.newService.number,
          address: this.newService.address,
          city: this.newService.city._id,
          contact: {
            phoneNumber: this.newService.contact.phoneNumber,
            name: this.newService.contact.name,
            email: this.newService.contact.email,
          },
          assignedTo: assigned,
          owner: this.newService.client._id,
          contractType: this.newService.contractType,
          //billType: this.newService.billType,
          tariff: this.newService.tariff._id,
        })
        .then((respuesta) => {
          return respuesta;
        })
        .then((data) => {
          this.data.servicio = null;
          if (data.status == 200) {
            this.edit_service = !this.edit_service;
            this.newService.snumber = null;
            this.newService.address = null;
            this.newService.contact.phoneNumber = null;
            this.newService.contact.name = null;
            this.newService.contact.email = null;
            this.newService.assignedTo = null;
            this.newService.owner = null;
            this.newService.contractType = null;
            //this.newService.billType = null;
            this.newService.tariff = null;
            this.isLoading = false;
          } else {
            if (data.status == 202) {
              this.makeToast(
                this.$bvToast.toast("Servicio ya existe", {
                  title: "Error",
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                  solid: true,
                })
              );
            }
          }
        })
        .then((update) => {
          let me = this;
          axios
            .get("snumbers/" + this.data.cliente._id)
            .then(function(response) {
              me.servicios = response.data;
            })
            .catch(function(error) {});
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editarServices() {
      this.edit_service = !this.edit_service;
      this.newService.number = this.data.servicio.snumber;
      this.newService.address = this.data.servicio.address;
      this.newService.contact.name = this.data.servicio.contact.name;
      this.newService.contact.phoneNumber = this.data.servicio.contact.phoneNumber;
      this.newService.contact.email = this.data.servicio.contact.email;

      //this.newService.billType = this.data.servicio.billType;
      this.newService.contractType = this.data.servicio.contractType;

      this.newService.tariff = this.data.servicio.tariff;
      this.newService.city = this.data.servicio.city;

      this.newService.client = this.data.servicio.owner;
    },
    GetPerdida(Orientacion, Inclinacion) {
      for (let index = 0; index < this.perdidas.length; index++) {
        if (
          this.perdidas[index].Orientacion == Orientacion &&
          this.perdidas[index].Inclinacion == Inclinacion
        ) {
          return this.perdidas[index].value;
        }
      }
    },
    ConsumoMensual(event, index, item) {
      if (this.data.tipo_recibo == "Medio") {
        if (this.data.tipo_ingreso == "Medio") {
          this.data.consumo_mensual[index].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 1].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 12].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 13].consumo =
            this.data.data_consumo[index].consumo / 2;

          this.data.consumo_mensual[index].precio_promedio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 1].precio_promedio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 12].precio_promedio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 13].precio_promedio =
            this.data.data_consumo[index].pago / 2;

          //calculo
          this.data.consumo_mensual[index].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
          this.data.consumo_mensual[index + 1].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
          this.data.consumo_mensual[index + 12].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
          this.data.consumo_mensual[index + 13].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
        } else {
          this.data.consumo_mensual[index].consumo = this.data.data_consumo[
            index
          ].consumo;
          this.data.consumo_mensual[
            index + 12
          ].consumo = this.data.data_consumo[index].consumo;

          this.data.consumo_mensual[
            index
          ].precio_promedio = this.data.data_consumo[index].pago;
          this.data.consumo_mensual[
            index + 12
          ].precio_promedio = this.data.data_consumo[index].pago;

          //calculo
          this.data.consumo_mensual[index].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
          this.data.consumo_mensual[index + 12].precio = (
            this.data.consumo_mensual[index].consumo *
            this.data.consumo_mensual[index].precio_promedio *
            1.16
          ).toFixed(2);
        }
      } else {
        if (this.data.tipo_ingreso == "Medio") {
          this.data.consumo_mensual[index].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 1].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 12].consumo =
            this.data.data_consumo[index].consumo / 2;
          this.data.consumo_mensual[index + 13].consumo =
            this.data.data_consumo[index].consumo / 2;

          this.data.consumo_mensual[index].precio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 1].precio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 12].precio =
            this.data.data_consumo[index].pago / 2;
          this.data.consumo_mensual[index + 13].precio =
            this.data.data_consumo[index].pago / 2;

          this.data.consumo_mensual[index].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
          this.data.consumo_mensual[index + 1].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
          this.data.consumo_mensual[index + 12].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
          this.data.consumo_mensual[index + 13].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
        } else {
          this.data.consumo_mensual[index].consumo = this.data.data_consumo[
            index
          ].consumo;
          this.data.consumo_mensual[
            index + 12
          ].consumo = this.data.data_consumo[index].consumo;

          this.data.consumo_mensual[index].precio = this.data.data_consumo[
            index
          ].pago;
          this.data.consumo_mensual[index + 12].precio = this.data.data_consumo[
            index
          ].pago;

          this.data.consumo_mensual[index].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
          this.data.consumo_mensual[index + 12].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
        }
      }

      /**   
      if (this.data.tipo_recibo == "Mensuala") {
        this.data.consumo_mensual[
          index + 12
        ].consumo = this.data.consumo_mensual[index].consumo;
        this.data.consumo_mensual[
          index + 12
        ].precio = this.data.consumo_mensual[index].precio;
      } else {
        this.data.consumo_mensual[index].consumo =
          this.data.consumo_mensual_medio[index].consumo / 2;
        this.data.consumo_mensual[index + 1].consumo =
          this.data.consumo_mensual_medio[index].consumo / 2;
        this.data.consumo_mensual[index].precio =
          this.data.consumo_mensual_medio[index].precio / 2;
        this.data.consumo_mensual[index + 1].precio =
          this.data.consumo_mensual_medio[index].precio / 2;

        this.data.consumo_mensual[index + 12].consumo =
          this.data.consumo_mensual_medio[index].consumo / 2;
        this.data.consumo_mensual[index + 13].consumo =
          this.data.consumo_mensual_medio[index].consumo / 2;
        this.data.consumo_mensual[index + 12].precio =
          this.data.consumo_mensual_medio[index].precio / 2;
        this.data.consumo_mensual[index + 13].precio =
          this.data.consumo_mensual_medio[index].precio / 2;
      } 
      */
    },
    vaciarConsumo() {
      for (let index = 0; index < this.data.data_consumo.length; index++) {
        this.data.data_consumo[index].consumo = null;
        this.data.data_consumo[index].pago = null;
      }
      for (let index = 0; index < this.data.consumo_mensual.length; index++) {
        this.data.consumo_mensual[index].consumo = null;
        this.data.consumo_mensual[index].precio = null;
        this.data.consumo_mensual[index].precio_promedio = null;
      }
    },
    CalcularPromedio() {
      if (this.data.servicio.billType === "Medio") {
        for (let index = 0; index < this.data.consumo_mensual.length; index++) {
          //(consumo*pagomedio)*1.16
          this.data.consumo_mensual[
            index
          ].precio_promedio = this.data.consumo_mensual[index].precio;
          this.CalcularPago(index);
        }
      } else {
        for (let index = 0; index < this.data.consumo_mensual.length; index++) {
          this.data.consumo_mensual[index].precio_promedio = (
            this.data.consumo_mensual[index].precio /
            1.16 /
            this.data.consumo_mensual[index].consumo
          ).toFixed(2);
          this.CalcularPago(index);
        }
      }
    },
    CalcularPago(index) {
      if (this.data.servicio.billType === "Medio") {
        this.data.consumo_mensual[index].precio_calculado = (
          this.data.consumo_mensual[index].consumo *
          this.data.consumo_mensual[index].precio_promedio *
          1.16
        ).toFixed(2);
      } else {
        this.data.consumo_mensual[
          index
        ].precio_calculado = this.data.consumo_mensual[index].precio;
      }

      
    },
    formatKwh(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    addQuote() {
      let me = this;
      me.data.rows = me.rows;
      if(me.packageSelected == 'original'){
        me.data.packageSelected = me.packageSelected;
      } else {
        me.data.packageSelected = me.packageSelected;
      }
      me.data.ahorroAnual = me.ahorroAnual;
      me.data.retornoInversion = (
        me.totalMasCuotaPesos / me.ahorroAnual
      ).toFixed(2);
      let pack = {
        products: [],
      };
      let productsList = [];
      for (const r of this.rows) { 
        pack.products.push({
          product: this.products[r.product]._id,
          quantity: r.quantity,
          disc: r.disc,
          discPesos: r.discPesos,
        });
        productsList.push({
          productName: `${this.products[r.product].productName}`,
          type: `${this.products[r.product].type.name}`,
          capacity: `${this.products[r.product].capacity}`, 
          quantity: r.quantity,
          unitPrice: this.products[r.product].price,
          unitPromotionalPrice: this.products[r.product].priceWDisc,
          discount: r.disc,
          discountPesos: r.discPesos,
          totalPrice: r.price,
        });
      }
      this.data.pack = pack;
      this.data.packageForReport = {
        productList: productsList,
        subtotal: this.subtotal,
        subtotalPesos: this.subtotalPesos,
        total: this.totalUSD,
        totalPesos: this.totalPesos,
        totalIVA: this.totalIVA,
        totalIVAPesos: this.totalIVAPesos,
        disc: this.disc,
        discPesos: this.discPesos,
        iva: this.iva,
        dollar: this.dollar,
      };
      axios
        .post("quotes", {
          employee: this.$store.state.usuario._id,
          customer: this.data.cliente._id,
          data: this.data,
          public: this.status
        })
        .then((res) => {
          this.$router.push({
            name: "cotizacion_confirmado",
            params: { id: res.data },
          });
        })
        .then(function(response) {
          return response;
        })
        .catch(function(error) {});
    },
    putQuote() {
      let me = this;
      me.data.rows = me.rows;
      me.data.packageSelected = me.packageSelected;
      me.data.ahorroAnual = me.ahorroAnual;
      me.data.retornoInversion = (
        me.totalMasCuotaPesos / me.ahorroAnual
      ).toFixed(2);
      let pack = {
        products: [],
      };
      let productsList = [];
      for (const r of this.rows) { 
        pack.products.push({
          product: this.products[r.product]._id,
          quantity: r.quantity,
          disc: r.disc,
          discPesos: r.discPesos,
        });
        productsList.push({
          productName: `${this.products[r.product].productName}`,
          type: `${this.products[r.product].type.name}`,
          capacity: `${this.products[r.product].capacity}`, 
          quantity: r.quantity,
          unitPrice: this.products[r.product].price,
          unitPromotionalPrice: this.products[r.product].priceWDisc,
          discount: r.disc,
          discountPesos: r.discPesos,
          totalPrice: r.price,
        });
      }
      this.data.pack = pack;
      this.data.packageForReport = {
        productList: productsList,
        subtotal: this.subtotal,
        subtotalPesos: this.subtotalPesos,
        total: this.totalUSD,
        totalPesos: this.totalPesos,
        totalIVA: this.totalIVA,
        totalIVAPesos: this.totalIVAPesos,
        disc: this.disc,
        discPesos: this.discPesos,
        iva: this.iva,
        dollar: this.dollar,
      };
      axios
        .put("quotation/" + this.$route.params.id, {
          employee: this.employee,
          customer: this.data.cliente._id,
          data: this.data,
          public: this.status
        })
        .then(() => {
          this.$router.push({
            name: "cotizacion_confirmado",
            params: { id: this.$route.params.id },
          });
        })
        .then(function(response) {
          return response;
        })
        .catch(function(error) {});
    },
    getCotizacion() {
      let me = this;
      if (this.$route.params.id) {
        axios
          .get("quotation/" + this.$route.params.id)

          .then(function(response) { 
            me.status = response.data.public;
            me.data = response.data.data;
            me.data.rows = response.data.data.rows;
            me.data.packageSelected = response.data.data.packageSelected;
            me.packageSelected = "original"; 
            //me.packageSelected = response.data.data.packageSelected;
            me.packages.push()
            me.employee = response.data.employee;
            me.getEmpleados();
          })

          .catch(function(error) {});
      }
    },
    CalcularPago1D(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 175) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano1;
          }
          if (consumo_temp > 175 && consumo_temp <= 400) {
            pago_basico =
              175 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano1;
            consumo_temp = consumo_temp - 175;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano2;
          }
          if (consumo_temp > 400 && consumo_temp <= 600) {
            pago_basico =
              175 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano1;
            pago_intermedio_bajo =
              225 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano2;
            consumo_temp = consumo_temp - 400;
            consumo_intermedio_alto = consumo_temp;
            pago_intermedio_alto =
              consumo_intermedio_alto *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano3;
          }
          if (consumo_temp > 600) {
            pago_basico =
              175 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano1;
            pago_intermedio_bajo =
              225 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano2;
            pago_intermedio_alto =
              200 *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano3;
            consumo_temp = consumo_temp - 600;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1D").data.Verano4;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno2;
            }
            if (consumo_temp > 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno1;
              pago_intermedio_bajo =
                125 *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno2;
              consumo_temp = consumo_temp - 200;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1D").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1F(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 300) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano1;
          }
          if (consumo_temp > 300 && consumo_temp <= 1200) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano1;
            consumo_temp = consumo_temp - 300;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano2;
          }

          if (consumo_temp > 1200 && consumo_temp <= 2500) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano1;
            pago_intermedio_bajo =
              900 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano2;
            consumo_temp = consumo_temp - 1200;
            consumo_intermedio_alto = consumo_temp;
            pago_intermedio_alto =
              consumo_intermedio_alto *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano3;
          }
          if (consumo_temp > 2500) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano1;
            pago_intermedio_bajo =
              900 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano2;
            pago_intermedio_alto =
              1300 *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano3;
            consumo_temp = consumo_temp - 2500;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1F").data.Verano4;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno2;
            }
            if (consumo_temp > 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno1;
              pago_intermedio_bajo =
                125 *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno2;
              consumo_temp = consumo_temp - 200;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1F").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1C(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 150) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano1;
          }
          if (consumo_temp > 150 && consumo_temp <= 300) {
            pago_basico =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano1;
            consumo_temp = consumo_temp - 150;
            consumo_intermedio_bajo = consumo_temp;

            pago_intermedio_bajo =
              consumo_intermedio_bajo *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano2;
          }
          if (consumo_temp > 300 && consumo_temp <= 450) {
            pago_basico =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano1;
            pago_intermedio_bajo =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano2;
            consumo_temp = consumo_temp - 300;
            consumo_intermedio_alto = consumo_temp;
            pago_intermedio_alto =
              consumo_intermedio_alto *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano3;
          }
          if (consumo_temp > 450) {
            pago_basico =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano1;
            pago_intermedio_bajo =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano2;
            pago_intermedio_alto =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano3;
            consumo_temp = consumo_temp - 450;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1C").data.Verano4;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 175) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno2;
            }
            if (consumo_temp > 175) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno1;
              pago_intermedio_bajo =
                100 *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno2;
              consumo_temp = consumo_temp - 175;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1C").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1E(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 300) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano1;
          }
          if (consumo_temp > 300 && consumo_temp <= 750) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano1;
            consumo_temp = consumo_temp - 300;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano2;
          }

          if (consumo_temp > 750 && consumo_temp <= 900) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano1;
            pago_intermedio_bajo =
              450 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano2;
            consumo_temp = consumo_temp - 750;
            consumo_intermedio_alto = consumo_temp;
            pago_intermedio_alto =
              consumo_intermedio_alto *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano3;
          }
          if (consumo_temp > 900) {
            pago_basico =
              300 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano1;
            pago_intermedio_bajo =
              450 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano2;
            pago_intermedio_alto =
              150 *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano3;
            consumo_temp = consumo_temp - 900;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1E").data.Verano4;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno2;
            }
            if (consumo_temp > 200) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno1;
              pago_intermedio_bajo =
                125 *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno2;
              consumo_temp = consumo_temp - 200;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1E").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1B(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 125) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano1;
          }
          if (consumo_temp > 125 && consumo_temp <= 225) {
            pago_basico =
              125 *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano1;
            consumo_temp = consumo_temp - 125;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano2;
          }
          if (consumo_temp > 225) {
            pago_basico =
              125 *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano1;
            pago_intermedio_bajo =
              100 *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano2;

            consumo_temp = consumo_temp - 225;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1B").data.Verano3;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 175) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno2;
            }
            if (consumo_temp > 175) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno1;
              pago_intermedio_bajo =
                100 *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno2;
              consumo_temp = consumo_temp - 175;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1A(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [16, 17, 18, 19, 20, 21];
        var invierno = [12, 13, 14, 15, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 100) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano1;
          }
          if (consumo_temp > 100 && consumo_temp <= 150) {
            pago_basico =
              100 *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano1;
            consumo_temp = consumo_temp - 100;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano2;
          }
          if (consumo_temp > 150) {
            pago_basico =
              100 *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano1;
            pago_intermedio_bajo =
              50 *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano2;

            consumo_temp = consumo_temp - 150;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1A").data.Verano3;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        } else {
          if (invierno.includes(index)) {
            var pago_excedente = 0;
            var pago_intermedio_alto = 0;
            var pago_intermedio_bajo = 0;
            var pago_basico = 0;
            var consumo_excedente = 0;
            var consumo_intermedio_alto = 0;
            var consumo_intermedio_bajo = 0;
            var consumo_basico = 0;
            // basico
            if (consumo_temp <= 75) {
              consumo_basico = consumo_temp;
              pago_basico =
                consumo_basico *
                this.tarifas.find((tarifa) => tarifa.name === "1A").data
                  .Invierno1;
            }
            if (consumo_temp > 75 && consumo_temp <= 150) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1A").data
                  .Invierno1;
              consumo_temp = consumo_temp - 75;
              consumo_intermedio_bajo = consumo_temp;
              pago_intermedio_bajo =
                consumo_intermedio_bajo *
                this.tarifas.find((tarifa) => tarifa.name === "1B").data
                  .Invierno2;
            }
            if (consumo_temp > 150) {
              pago_basico =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1A").data
                  .Invierno1;
              pago_intermedio_bajo =
                75 *
                this.tarifas.find((tarifa) => tarifa.name === "1A").data
                  .Invierno2;
              consumo_temp = consumo_temp - 175;
              consumo_excedente = consumo_temp;
              pago_excedente =
                consumo_excedente *
                this.tarifas.find((tarifa) => tarifa.name === "1A").data
                  .Invierno3;
            }
            this.data.consumo_mensual_ahorro[index].pago = (
              (pago_basico +
                pago_intermedio_bajo +
                pago_intermedio_alto +
                pago_excedente +
                40) *
              1.16
            ).toFixed(2);
          }
        }
      }
    },
    CalcularPago1(index) {
      if (this.tarifas != null) {
        var consumo_temp = this.data.consumo_mensual_ahorro[index].consumo;
        var verano = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        if (verano.includes(index)) {
          var pago_excedente = 0;
          var pago_intermedio_alto = 0;
          var pago_intermedio_bajo = 0;
          var pago_basico = 0;

          var consumo_excedente = 0;
          var consumo_intermedio_alto = 0;
          var consumo_intermedio_bajo = 0;
          var consumo_basico = 0;
          if (consumo_temp <= 75) {
            consumo_basico = consumo_temp;
            pago_basico =
              consumo_basico *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano1;
          }
          if (consumo_temp > 75 && consumo_temp <= 140) {
            pago_basico =
              75 *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano1;
            consumo_temp = consumo_temp - 75;
            consumo_intermedio_bajo = consumo_temp;
            pago_intermedio_bajo =
              consumo_temp *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano2;
          }
          if (consumo_temp > 140) {
            pago_basico =
              75 *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano1;
            pago_intermedio_bajo =
              65 *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano2;

            consumo_temp = consumo_temp - 140;
            consumo_excedente = consumo_temp;
            pago_excedente =
              consumo_excedente *
              this.tarifas.find((tarifa) => tarifa.name === "1").data.Verano3;
          }
          this.data.consumo_mensual_ahorro[index].pago = (
            (pago_basico +
              pago_intermedio_bajo +
              pago_intermedio_alto +
              pago_excedente +
              40) *
            1.16
          ).toFixed(2);
        }
      }
    },
    getTotalPrice(index) {
      if (this.rows[index].product != null) {
        if (
          this.products[this.rows[index].product].priceWDisc &&
          this.products[this.rows[index].product].priceWDisc > 0
        ) {
          this.rows[index].price =
            this.products[this.rows[index].product].priceWDisc *
              this.rows[index].quantity -
            this.rows[index].disc -
            this.rows[index].discPesos / this.dollar;
          this.rows[index].pricePesos = this.rows[index].price * this.dollar;
        } else {
          this.rows[index].price =
            this.products[this.rows[index].product].price *
              this.rows[index].quantity -
            this.rows[index].disc -
            this.rows[index].discPesos / this.dollar;
          this.rows[index].pricePesos = this.rows[index].price * this.dollar;
        }
      } else {
        this.rows[index].price = 0;
        this.rows[index].quantity = 1;
      }
      this.getTotal();  
    },
    getTotal() {
      this.subtotal = 0;
      let sumaUSD = this.rows.reduce((total, item) => {
        return item.price + total;
      }, 0);
      this.subtotal = sumaUSD;
      this.totalIVA = this.subtotal * (this.iva / 100);
      this.totalUSD = this.subtotal + this.totalIVA;
      if (isNaN(this.disc)) {
        this.disc = 0;
      }
      if (isNaN(this.discPesos)) {
        this.discPesos = 0;
      }
      this.totalUSD -= this.disc - this.discPesos / this.dollar;
      this.subtotalPesos = this.subtotal * this.dollar;
      this.totalIVAPesos = this.subtotalPesos * (this.iva / 100);
      this.totalPesos =
        this.subtotalPesos +
        this.totalIVAPesos -
        this.disc * this.dollar -
        this.discPesos;

      this.cuota = 0;
      //this.cuota = (this.totalUSD * this.percentage) / 100;
      this.cuotaPesos = this.cuota * this.dollar;
      this.totalMasCuota = this.totalUSD + this.cuota;
      this.totalMasCuotaPesos = this.totalMasCuota * this.dollar;


    },
    verifyQuantity(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 47 && charCode < 58) {
        return true;
      } else {
        event.preventDefault();
      } 
    },
    getDiscountValue(value) {
      this.disc = parseFloat(value);
      this.getTotal();
    },
    getDiscountPesosValue(value) {
      this.discPesos = parseFloat(value);
      this.getTotal();
    },
    selectPackage() {
      let products = [];
      if (this.packageSelected === "") {
        products = [
          {
            type: null,
            product: null,
            quantity: 1,
            products: [],
            options: [...this.AllProductsOptions],
            compatibility: null,
            price: 0,
            pricePesos: 0,
            disc: 0,
            discPesos: 0,
            showDisc: false,
          },
        ];
      } else if (this.packageSelected === "original") {   
        const selectedPackage = this.packages.filter(
          (pack) => pack.packageName === this.data.packageSelected
        )[0]; 
        this.packages.push({"packageName":"original", "products": this.data.rows, "automatic": true});
        products = this.data.rows;
      } else {
        const selectedPackage = this.packages.filter(
          (pack) => pack.packageName === this.packageSelected
        )[0];
        if (selectedPackage) {
          this.delete_package = false;
          selectedPackage.products.map((element) => {
            let options = [this.AllProductsOptions[0]];
            const newOptions = this.products.filter(
              (p) => p.type._id == element.type
            );
            newOptions.map((p) => {
              if (p.brand != null) {
                options.push({
                  text: `${p.productName} Marca: ${p.brand.name}`,
                  value: this.products.indexOf(p),
                });
              } else {
                options.push({
                  text: `${p.productName} Marca: N/A`,
                  value: this.products.indexOf(p),
                });
              }
            });
            const p = this.products.filter((e) => e._id === element.product);
            if (p.length > 0) {
              const productIndex = this.products.indexOf(p[0]);
              const product = this.products[productIndex];
              let row = {
                type: element.type,
                product: productIndex,
                quantity: element.quantity,
                options: options,
                compatibility: null,
                disc: element.disc,
                discPesos: element.discPesos,
                showDisc: false,
              };
              if (product.priceWDisc && product.priceWDisc > 0) {
                row.price =
                  this.products[productIndex].priceWDisc * element.quantity -
                  element.disc -
                  element.discPesos / this.dollar;
                row.pricePesos =
                  this.products[productIndex].priceWDisc *
                    this.dollar *
                    element.quantity -
                  element.disc * this.dollar -
                  element.discPesos;
              } else {
                row.price =
                  this.products[productIndex].price * element.quantity -
                  element.disc -
                  element.discPesos / this.dollar;
                row.pricePesos =
                  this.products[productIndex].price *
                    this.dollar *
                    element.quantity -
                  element.disc * this.dollar -
                  element.discPesos;
              }
              products.push(row);
            }
          });
        } else {
          this.packageSelected = "";
          this.delete_package = true;
        }
      }

      this.rows = products;
      this.getTotal();
    },
    selectProduct(index){
       this.CalcularProductos();
      this.getTotalPrice(index); 
      
    },
    CalcularProductos() {
      let tmpPanel = 0;
      if (this.packageSelected) {
        if (
          this.packages.filter(
            (word) => word.packageName == this.packageSelected
          )[0].automatic == true
        ) {
          if (this.rows != null) {
            let tamanoValue = this.data.tamano * 1000;
            if (
              this.rows != null &&
              this.packages.filter(
                (word) => word.packageName == this.packageSelected
              )[0].automatic == true
            ) {
              for (let index = 0; index < this.rows.length; index++) {
                if (
                  this.products[this.rows[index].product].type.name ==
                    "Paneles solares" ||
                  this.products[this.rows[index].product].type.name ==
                    "Inversores"
                ) {
                  this.rows[index].quantity = Math.ceil(
                    parseFloat(
                      tamanoValue /
                        this.products[this.rows[index].product].capacity
                    )
                  );

                  if (this.products[this.rows[index].product].type.name == "Paneles solares") {
                    tmpPanel = this.rows[index].quantity;
                    this.data.tamano_total_panekes = (this.products[this.rows[index].product].capacity*tmpPanel)/1000;
                  }
                  this.getTotalPrice(index);
                }
                if (
                  this.products[this.rows[index].product].type.name ==
                    "Adicionales de estructuras" ||
                  this.products[this.rows[index].product].type.name ==
                    "Montajes" ||
                  this.products[this.rows[index].product].type.name ==
                    "Estructuras"
                ) {
                  this.rows[index].quantity = tmpPanel;
                  this.getTotalPrice(index);
                }
                if (
                  this.products[this.rows[index].product].type.name ==
                  "Materiales de instalación eléctrica"
                ) {
                  this.rows[index].quantity = this.tamano;
                  this.getTotalPrice(index);
                }
              }
            }
          }
        } 
      }
    },
    getServicios() {
      let me = this;
      axios
        .get("assignedsnumbers/" + this.$store.state.usuario._id)
        .then(function(response) {
          me.servicios = response.data;
        })
        .catch(function(error) {});
    },
    getEmpleados() { 
      let me = this; 
      this.isLoading = true; 
      axios
        .get("users/" + this.$store.state.usuario._id+'/status=true')
        .then(res => {    
            me.usuarios_empleados = res.data;     
        })
        .then( res => { 
          me.isLoading = false;
        })
        .catch(error => {});
    },
    cambiarEmpleado(){
      this.employee = this.usuarios_empleados_seleccionado._id;
      this.putQuote();
    }
  },
  computed: {
    total() {
      if (this.data.servicio) {
        this.data.total = (
          this.data.consumo_mensual.reduce(
            (acc, item) => Number(acc) + Number(item.precio),
            0
          ) / 2
        ).toFixed(2);
      }
      return this.data.total;
    },
    consumo_total() {
      this.data.consumo_total = (
        this.data.consumo_mensual.reduce(
          (acc, item) => Number(acc) + Number(item.consumo),
          0
        ) / 2
      ).toFixed(2);
      return this.data.consumo_total;
    },
    medio_total() {
      this.data.medio_total = (
        this.data.consumo_mensual.reduce(
          (acc, item) => Number(acc) + Number(item.precio_promedio),
          0
        ) / 2
      ).toFixed(2);
      return this.data.medio_total;
    },
    ahorro_consumo_total() {
      this.data.ahorro_consumo_total = (
        this.data.consumo_mensual_ahorro.reduce(
          (acc, item) => Number(acc) + Number(item.consumo),
          0
        ) / 2
      ).toFixed(2);
      return this.data.medio_total;
    },
    ahorro_total() {
      this.data.ahorro_total = (
        this.data.consumo_mensual_ahorro.reduce(
          (acc, item) => Number(acc) + Number(item.pago),
          0
        ) / 2
      ).toFixed(2);
      return this.data.medio_total;
    },
    tamano() {
      let tamano = 0;
      let tamano2 = 0;
 if (this.data.servicio && this.data.servicio.contractType === "Industrial") {
          this.data.costo_promedio_tarifa = 
          (
            (parseFloat(this.data.total) - (parseFloat(643)*12)) /1.16) 
    
      /(parseFloat(this.data.consumo_total)).toFixed(2);
    
   
 } else {
      this.data.costo_promedio_tarifa = (
        parseFloat(this.data.total / 2) /
        1.16 /
        parseFloat(this.data.consumo_total / 2)
      ).toFixed(2);
 }
 
      if (
        this.packages.filter(
          (word) => word.packageName == this.packageSelected
        )[0]
      ) {
        if (
          this.rows != null &&
          this.packages.filter(
            (word) => word.packageName == this.packageSelected
          )[0].automatic == true
        ) {
          if (this.data.servicio != null) {
            
            let porcentaje = this.data.porcentaje_cobertura / 100;

            // Generacion ciudad - perdida
            tamano = (
              (this.data.consumo_total * porcentaje) /
              this.data.servicio.city.generate
            ).toFixed(2);
            this.data.tamano = tamano;
              
          }
        } else {
          if (this.data.servicio != null && this.packageSelected) {
            let porcentaje = this.data.porcentaje_cobertura / 100;

            for (let index = 0; index < this.rows.length; index++) {
              if (
                this.products[this.rows[index].product].type.name ==
                "Paneles solares"
              ) {
                tamano =
                  (this.rows[index].quantity *
                    this.products[this.rows[index].product].capacity) /
                  1000;
              }
            }
            this.data.tamano = tamano;
            this.data.tamano_total_panekes = tamano;
          }
        }
      }
      // Calcular costo por watt
      this.data.costoWatt = (this.subtotal / (this.data.tamano * 1000)).toFixed(
        2
      );
      
      return this.data.tamano_total_panekes;
    },
    ProduccionMensual: function() {
      if (this.data.servicio != null) {
        let produccion_mensual = (
          (this.data.tamano *
            (this.data.servicio.city.generate *
              (1 +
                this.GetPerdida(
                  this.data.perdida.inclinacion,
                  this.data.perdida.orientacion
                ) /
                  100))) /
          12
        ).toFixed(2); 

        this.data.consumo_mensual_ahorro[0].consumo = parseFloat(
          this.data.consumo_mensual[0].consumo - produccion_mensual
        ).toFixed(2);
        for (
          let index = 1;
          index < this.data.consumo_mensual_ahorro.length;
          index++
        ) {
          this.calculos_generacion_inclinacion[index].generacion = ((produccion_mensual*12)*this.generacion_inclinacion(this.data.perdida.inclinacion, index)).toFixed(2);
          this.data.calculos_generacion_inclinacion = this.calculos_generacion_inclinacion;
          if (this.data.consumo_mensual_ahorro[index - 1].consumo < 0) {
            this.data.consumo_mensual_ahorro[index].consumo = (
              parseFloat(this.data.consumo_mensual_ahorro[index - 1].consumo) +
              parseFloat(this.data.consumo_mensual[index].consumo) -
               ((produccion_mensual*12)*this.generacion_inclinacion(this.data.perdida.inclinacion, index))
            ).toFixed(2);

             
          } else {
            this.data.consumo_mensual_ahorro[index].consumo = (
              parseFloat(this.data.consumo_mensual[index].consumo) -
              ((produccion_mensual*12)*this.generacion_inclinacion(this.data.perdida.inclinacion, index))
            ).toFixed(2);
         
            //this.data.consumo_mensual_ahorro[index].consumo = this.generacion_inclinacion(this.data.perdida.inclinacion, index);
          }
          if (this.data.consumo_mensual_ahorro[index].consumo > 0) {
            if (this.data.servicio.contractType === "Doméstico") {
              var verano = [16, 17, 18, 19, 20, 21];
              var invierno = [12, 13, 14, 15, 22, 23];
              if (this.data.servicio.tariff.name == "1D") {
                this.CalcularPago1D(index);
              }
              if (this.data.servicio.tariff.name == "1C") {
                this.CalcularPago1C(index);
              }
              if (this.data.servicio.tariff.name == "1E") {
                this.CalcularPago1E(index);
              }
              if (this.data.servicio.tariff.name == "1F") {
                this.CalcularPago1F(index);
              }
              if (this.data.servicio.tariff.name == "1B") {
                this.CalcularPago1B(index);
              }
              if (this.data.servicio.tariff.name == "1A") {
                this.CalcularPago1A(index);
              }
              if (this.data.servicio.tariff.name == "1") {
                this.CalcularPago1(index);
              }
            } else {
              if (this.data.servicio.contractType === "Comercial") {
                this.data.consumo_mensual_ahorro[index].pago = (
                  (parseFloat(this.data.consumo_mensual_ahorro[index].consumo) *
                    parseFloat(this.data.costo_promedio_tarifa) +
                    63) *
                  1.16
                ).toFixed(2);
              } else {
                if (this.data.servicio.contractType === "Industrial") {
                  this.data.consumo_mensual_ahorro[index].pago = (
                    (parseFloat(
                      this.data.consumo_mensual_ahorro[index].consumo
                    ) *
                      parseFloat(this.data.costo_promedio_tarifa) +
                      643) *
                    1.16
                  ).toFixed(2);
                }
              }
            }
          } else {
            if (this.data.servicio.contractType === "Doméstico") {
              this.data.consumo_mensual_ahorro[index].pago = 40 * 1.16;
            }
            if (this.data.servicio.contractType === "Comercial") {
              this.data.consumo_mensual_ahorro[index].pago = 63 * 1.16;
            }
            if (this.data.servicio.contractType === "Industrial") {
              this.data.consumo_mensual_ahorro[index].pago = 643 * 1.16;
            }
          }
        }
        this.ahorroAnual = (
          this.total -
          this.data.consumo_mensual_ahorro
            .slice(12, 24)
            .reduce((acc, item) => Number(acc) + Number(item.pago), 0)
        ).toFixed(2);
        if (
          this.packages.filter(
            (word) => word.packageName == this.packageSelected
          )[0]
        ) {
          if (
            !this.packages.filter(
              (word) => word.packageName == this.packageSelected
            )[0].automatic == true
          ) {
            this.data.porcentaje_cobertura = (
              (this.ahorroAnual / this.total) *
              100
            ).toFixed(2);
          }
        }
        this.data.ProduccionMensual = produccion_mensual;
        return produccion_mensual;
      }
    },
  },
};
</script>
<style>
#cotizador {
  font-family: "Karla", sans-serif;
}
#cotizador .input_consumo {
  height: 30px;
}
#cotizador .input-group {
  height: 43px;
}
#cotizador .input-group input.input_consumo {
  margin-top: 6px;
}

#cotizador #consumo,
#cotizador #proyecto_solar {
  font-family: "Karla", sans-serif;
}
#cotizador #proyecto_solar span {
  color: #00ab63 !important;
  font-weight: bold;
  font-size: 25px;
}
#cotizador #proyecto_solar .toggle {
  background: #fff;
  -webkit-box-shadow: 0px 0px 75px 0px rgba(242, 242, 242, 1);
  -moz-box-shadow: 0px 0px 75px 0px rgba(242, 242, 242, 1);
  box-shadow: 0px 0px 75px 0px rgba(242, 242, 242, 1);
  color: #00ab63 !important;
}
#cotizador h2 {
  font-family: "Karla", sans-serif;
  font-weight: 700 !important;
  color: #000 !important;
  font-size: 32px !important;
}
#cotizador .style-chooser .vs__dropdown-menu {
  max-height: 200px;
}
#cotizador .btn {
  border: 3px solid transparent;
}
#cotizador .clienete_informacion {
  margin-top: 20px;
}
#cotizador h2,
#cotizador .col-form-label {
  font-weight: bold;
}
.btn.btn-createch2 {
  margin-left: 20px;
  border: 3px solid transparent;
  background: transparent;
  color: #414141 !important;
  border-color: #414141 !important;
}
.btn.btn-createch2:hover {
  color: #00ab63 !important;
  border-color: #00ab63 !important;
  background: transparent !important;
}
#consumo h3 {
  color: #00ab63;
  padding: 0px;
  margin: 0px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
}
#ahorro p {
  margin-bottom: 0;
}
#ahorro .ahorro .form-control-range {
  margin-top: 15px;
}
#ahorro .ahorro span {
  font-size: 15px;
}
#ahorro .ahorro h3 {
  color: black;
  padding: 0px;
  margin: 0px;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
}
#ahorro span {
  color: #00ab63;
  padding: 0px;
  margin: 0px;
  font-size: 30px;
  font-weight: bold;
}
#ahorro h3 {
  text-align: center;
}
.input-group-text {
  border: none !important;
  background: transparent !important;
}
.pruebas {
  max-height: 100%;
  overflow-y: scroll;
  scrollbar-color: #00ab63 #fff;
}

.fp-slidesNav ul li a span {
  background: #00ab63;
}
#cotizador .vs__search,
#cotizador .vs__selected-options,
#cotizador .vs__dropdown-toggle,
#cotizador .form-control,
#cotizador .custom-select {
  background: #f0f0f0 !important;
  border-radius: 20px !important;
}
#cotizador .vs__dropdown-toggle,
#cotizador .form-control,
#cotizador .custom-select {
  border: 1px solid #f0f0f0 !important;
  border-radius: 20px !important;
}
#cotizador .form-control:focus {
  box-shadow: none !important;
}

#cotizador .style-chooser .vs__search::placeholder,
#cotizador .style-chooser .vs__dropdown-toggle,
#cotizador .style-chooser .vs__dropdown-menu {
  background: #fff;
  border: none;
  color: #fff;
  border: 1px solid #f0f0f0;
  text-transform: lowercase;
  font-variant: small-caps;
  box-shadow: none;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #332f4a;
}

/* Actions buttons
    * --------------------------------------- */
.actions {
  position: absolute;
  top: 25%;
  width: 100%;
  left: 0;
  right: 0;
  padding: 20px;
  box-sizing: border-box;
}
.actions li {
  position: relative;
  z-index: 9999;
  margin: 0.3em 0.3em;
}
.actions-button {
  padding: 0.73em 1.47em;
  background: rgba(53, 73, 94, 0.47);
  border-radius: 5px;
  display: block;
  color: #fff;
  cursor: pointer;
}
/* Menu
    * --------------------------------------- */
#menu-line {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 159px;
  height: 2px;
  background: #fff;
}

#menu_cotizador {
  position: fixed;
  left: 0px;
  right: 0px;
  padding: 0px;
  margin: 20px 0px;
  top: 0px;
  z-index: 70;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  font-size: 1.1em;
}
#menu_cotizador li {
  text-align: center;
  width: 16.6666666667%;
  display: inline-block;
  padding: 0px;

  margin: 0px;
  position: relative;
}
#menu_cotizador a {
  color: #000;
  text-decoration: none;
  padding: 0 1.1em 1.1em 1.1em;
}
#menu_cotizador li.active a:after {
  content: "";
  text-decoration: none;
  margin: 0 1.1em 0 1.1em;
  height: 2px;
  background: #00ab63;
  display: block;
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  display: block;
}
.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  background-color: #00ab63;
  font-size: 12px;
  line-height: 1.42857;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 38px;
  line-height: 1.33;
}
.fp-slidesNav.fp-top {
  text-align: center;
}
.btn-createch {
  background-color: #00ab63 !important;
  border: #00ab63 !important;
}
</style>
